import DebugSettings from './DebugSettings';

export default {
  backend: {
    clientId: '3',
    clientSecret: 'KNJOaLylze8RCH5mjgsUQwLC0c9bAmUdEdxUQQOC',
    scopes: ['internal'],
    url: DebugSettings.useDevBackend ? 'http://localhost:8000' : 'https://analysenliste.spitaeler-sh.ch'
  }
};



// WEBPACK FOOTER //
// ./src/App/Config/index.js